// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".e78edb6b27252958dd81423170a0dee40b49fc58.chunk.bundle.js";
};